import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { AttributeContext, HorizontalValue } from './Attribute';

type AttributeGridProps = {
  children?: ReactNode;
} & (
  | {
      colCount?: never;

      /**
       * Display attributes in a stacked list with label first then value.
       * Set to `full-width` to expand to full width of container.
       * Incompatible with `colCount`.
       */
      horizontal?: HorizontalValue;
    }
  | {
      /**
       * Explicitly define number of columns for grid. Incompatible with `horizontal`.
       */
      colCount?: number;

      horizontal?: never;
    }
);

const AttributeGridComponent = styled.dl<{ colCount?: number; horizontal?: HorizontalValue }>`
  ${({ horizontal, colCount }) =>
    horizontal
      ? css`
          display: table;
          ${horizontal === 'full-width' &&
          css`
            width: 100%;
            table-layout: fixed;
            border-spacing: 0 ${Spacing[2]};
          `};
        `
      : css`
          display: grid;
          grid-column-gap: ${Spacing[4]};
          grid-row-gap: ${Spacing[4]};
          grid-template-columns: ${colCount
            ? `repeat(${colCount}, 1fr)`
            : 'repeat(auto-fit, minmax(225px, 1fr))'};
        `}
  margin: 0;

  & + & {
    padding-bottom: ${Spacing[5]};
  }
`;

const AttributeGrid = ({ children, horizontal, ...props }: AttributeGridProps) => {
  return (
    <AttributeGridComponent horizontal={horizontal} {...props}>
      {horizontal ? (
        <AttributeContext.Provider value={{ horizontal }}>{children}</AttributeContext.Provider>
      ) : (
        children
      )}
    </AttributeGridComponent>
  );
};

export default AttributeGrid;
